/* FTP cart sync (16 Oct 2026).
   The theme only redraws the cart drawer, header count and /cart totals when its OWN forms change the cart.
   Anything else that changes the cart (FTP quick add buttons, Essential Upsell, other apps) left them stale:
   header said 4, drawer showed 3; /cart lines updated but the subtotal and bottom bar did not.
   This watches every cart change made with fetch or XHR (Essential Upsell asks for the cart lines only, so even
   requests that ask for sections are followed up). Shortly after each change it fetches the cart drawer, header
   count and, on /cart, the lines, totals and delivery bar, and swaps in only the parts whose text has changed,
   so a part the theme already redrew is left alone. */
(function () {
  if (window.__ftpCartSync) return;
  window.__ftpCartSync = true;

  var CHANGE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  var timer = null;

  function root() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }
  function asksForSections(body) {
    try {
      if (!body) return false;
      if (typeof body === 'string') return body.indexOf('sections') > -1;
      if (window.FormData && body instanceof FormData) return body.has('sections');
      if (window.URLSearchParams && body instanceof URLSearchParams) return body.has('sections');
    } catch (e) {}
    return false;
  }
  function urlOf(input) { try { return typeof input === 'string' ? input : (input && input.url) || ''; } catch (e) { return ''; } }
  function schedule(ms) { clearTimeout(timer); timer = setTimeout(refresh, ms || 150); }

  if (window.fetch) {
    var _fetch = window.fetch;
    window.fetch = function (input, init) {
      var url = urlOf(input), watch = CHANGE.test(url), wait = asksForSections(init && init.body) ? 600 : 150;
      var p = _fetch.apply(this, arguments);
      if (watch) p.then(function (r) { if (r && r.ok) schedule(wait); }, function () {});
      return p;
    };
  }
  if (window.XMLHttpRequest) {
    var _open = XMLHttpRequest.prototype.open, _send = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (m, url) { this.__ftpUrl = url; return _open.apply(this, arguments); };
    XMLHttpRequest.prototype.send = function (body) {
      if (CHANGE.test(this.__ftpUrl || '')) {
        var wait = asksForSections(body) ? 600 : 150;
        this.addEventListener('load', function () { if (this.status >= 200 && this.status < 300) schedule(wait); });
      }
      return _send.apply(this, arguments);
    };
  }

  function norm(el) { return el ? (el.textContent || '').replace(/\s+/g, ' ').trim() : ''; }
  function parse(html) { return new DOMParser().parseFromString(html || '', 'text/html'); }
  function swap(target, fresh) {
    if (!target || !fresh) return false;
    if (norm(target) === norm(fresh) && target.querySelectorAll('img').length === fresh.querySelectorAll('img').length) return false;
    target.innerHTML = fresh.innerHTML;
    return true;
  }

  function refresh() {
    var parts = [], drawer = document.querySelector('cart-drawer');
    if (drawer && document.getElementById('CartDrawer')) parts.push('cart-drawer');
    if (document.getElementById('cart-icon-bubble')) parts.push('cart-icon-bubble');
    var page = [
      ['main-cart-items', '.js-contents'],
      ['main-cart-footer', '.js-contents-totals'],
      ['main-cart-shipping', '.js-contents-shipping']
    ].map(function (x) { var el = document.getElementById(x[0]); return el && el.dataset.id ? { el: el, id: el.dataset.id, sel: x[1] } : null; }).filter(Boolean);
    page.forEach(function (x) { parts.push(x.id); });
    if (!parts.length) return;

    Promise.all([
      fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }),
      fetch(root() + 'cart?sections=' + parts.join(',')).then(function (r) { return r.json(); })
    ]).then(function (res) {
      var cart = res[0], s = res[1] || {};
      if (s['cart-drawer'] && drawer) {
        var changed = swap(document.getElementById('CartDrawer'), parse(s['cart-drawer']).getElementById('CartDrawer'));
        drawer.classList.toggle('is-empty', cart.item_count === 0);
        if (changed) {
          var ov = drawer.querySelector('#CartDrawer-Overlay');
          if (ov && drawer.close) ov.addEventListener('click', drawer.close.bind(drawer));
          if (drawer.addCloseButtonHandlers) drawer.addCloseButtonHandlers();
        }
      }
      if (s['cart-icon-bubble']) {
        var b = parse(s['cart-icon-bubble']).querySelector('.shopify-section');
        swap(document.getElementById('cart-icon-bubble'), b);
      }
      page.forEach(function (x) {
        var doc = parse(s[x.id]);
        var fresh = doc.querySelector(x.sel) || doc.querySelector('.shopify-section');
        var target = x.el.querySelector(x.sel) || x.el;
        swap(target, fresh);
        x.el.classList.toggle('is-empty', cart.item_count === 0);
      });
      var ci = document.querySelector('cart-items');
      if (ci) ci.classList.toggle('is-empty', cart.item_count === 0);
      if (ci && ci.cartShipping && document.querySelector('.cart-shipping')) { try { ci.cartShipping(); } catch (e) {} }
      document.querySelectorAll('[data-cart-count], .header__cart-count').forEach(function (el) { el.textContent = cart.item_count; });
      document.dispatchEvent(new CustomEvent('ftp:cart-synced', { detail: cart }));
      if (Date.now() - quickAddAt < 4000) offerView();
    }).catch(function () {});
  }

  /* After an FTP quick add (homepage and bundle grids, planner), give the "Added to your cart" toast a
     View cart button that opens the drawer, now that the drawer holds the new item. */
  var quickAddAt = 0;
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-ftp-add]');
    if (b && b.getAttribute('data-ftp-after') !== 'cart') quickAddAt = Date.now();
  }, true);
  function openCart() {
    var d = document.querySelector('cart-drawer');
    if (d && d.open && document.getElementById('CartDrawer')) { d.open(); return; }
    window.location.href = root() + 'cart';
  }
  function offerView() {
    var t = document.querySelector('.ftp-toast');
    if (!t || !/added/i.test(t.textContent || '')) return;
    if (!t.querySelector('.ftp-toast__view')) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'ftp-toast__view';
      btn.textContent = 'View cart';
      btn.style.cssText = 'margin-left:1.2rem;padding:.4rem 1.2rem;border:1px solid currentColor;border-radius:10rem;background:transparent;color:inherit;font:inherit;font-weight:700;cursor:pointer;pointer-events:auto';
      btn.addEventListener('click', function (ev) { ev.preventDefault(); t.classList.remove('is-on'); openCart(); });
      t.appendChild(btn);
    }
    t.style.pointerEvents = 'auto';
    t.classList.add('is-on');
    clearTimeout(t._t);
    t._t = setTimeout(function () { t.classList.remove('is-on'); }, 4500);
  }

  window.ftpCartSync = refresh;
})();
